import { Icon } from '@blueprintjs/core';

import { IconBan } from './svg/IconBan';

import './Icon.style.sass';

export const CancelledGray = () => (
  <div className="cancelled">
    <Icon icon={<IconBan />} />
  </div>
);
